import { atom } from 'jotai';
import { atomFamily } from 'jotai-family';

export type LetterCreationState =
  | { status: 'idle' }
  | { status: 'creating-document' }
  | { status: 'streaming-document'; sourceDocumentId: string }
  | { status: 'creating-letter'; sourceDocumentId: string }
  | { status: 'done'; letterId: string }
  | { status: 'failed'; sourceDocumentId?: string; error: string };

export type LetterCreationProgress = {
  phase: LetterCreationState;
  sourceDocumentId?: string;
  /** Display name for the placeholder letter tab (template name, AI command, …). */
  name?: string;
  /** Synthetic id keying the loading LETTER tab for `createLetterFromScratch`. */
  temporaryId?: string;
};

/** Per-session in-flight letter creations. */
// eslint-disable-next-line @typescript-eslint/no-unused-vars
export const pendingLettersAtomFamily = atomFamily((_sessionId: string) =>
  atom<Array<LetterCreationProgress>>([])
);

/**
 * Per-session flag set by entry points (kebab + Create dropdown) when the
 * Create Document picker should route the next template / AI command pick
 * into `createLetterFromScratch` instead of `createDocument`. Read by
 * `CreateDocumentModal` from [[useCreateLetter]], set/cleared via the same
 * hook helpers so callers don't have to touch the atom directly.
 */
// eslint-disable-next-line @typescript-eslint/no-unused-vars
export const awaitingLetterTemplateAtomFamily = atomFamily((_sessionId: string) =>
  atom<boolean>(false)
);
